module.exports = __webpack_public_path__ + "static/media/logo-sho.7c1a0447.svg";